import type { DocumentId } from 'core/types';
import { CommentsRepository } from './Comments.repository';
import type { CommentModel } from './Comment.model';

export class CommentsService {
  commentsRepo: CommentsRepository = new CommentsRepository();

  getComment(id: DocumentId) {
    return this.commentsRepo.get(id);
  }

  create(comment: CommentModel) {
    return this.commentsRepo.create(comment);
  }

  update(comment: CommentModel) {
    return this.commentsRepo.update(comment);
  }

  getByType(typeName: string, id: DocumentId) {
    return this.commentsRepo.getByType(typeName, id);
  }

  getAll() {
    return this.commentsRepo.getAll();
  }
}
